import z from "zod";
import DietaryPreferenceService from "../../../../services/DietaryPreferenceService";
import { mapErrorsToFields } from "../../../../utils";

const api = new DietaryPreferenceService();
export type State = {
  message: string | null;
  errors?: {
    name?: string[];
    general?: string[];
  };
  success: boolean;
  defaultValues: {
    name?: string;
  };
};

const FormSchema = z.object({
  name: z.string().min(1, { message: "Name is required." }),
});

export async function createDietaryPreference(
  prevState: State,
  formData: FormData
): Promise<State> {
  const defaultValues = {
    name: formData.get("name")?.toString() || "",
  };
  try {
    const validatedFields = FormSchema.safeParse(defaultValues);
    if (!validatedFields.success) {
      return {
        errors: mapErrorsToFields(validatedFields.error),
        message: "Failed to create dietary preference.",
        defaultValues,
        success: false,
      };
    }
    const result = await api.createDietaryPreference(validatedFields.data);
    if (result.status === 201)
      return {
        errors: {},
        message: "Dietary Preference created successfully.",
        defaultValues,
        success: true,
      };
    else if (result.status === 400)
      return {
        errors: {},
        message: result.data.description,
        defaultValues,
        success: false,
      };
  } catch (error) {
    console.error("Error creating dietary preference:", error);
  }
  return {
    errors: {},
    message: "Failed to create dietary preference.",
    defaultValues,
    success: false,
  };
}

export async function updateDietaryPreference(
  id: string,
  prevState: State,
  formData: FormData
): Promise<State> {
  const defaultValues = {
    name: formData.get("name")?.toString() || "",
  };
  try {
    const validatedFields = FormSchema.safeParse(defaultValues);
    if (!validatedFields.success) {
      return {
        errors: mapErrorsToFields(validatedFields.error),
        message: "Failed to update dietary preference.",
        defaultValues,
        success: false,
      };
    }
    const result = await api.updateDietaryPreference({
      id: parseInt(id),
      ...validatedFields.data,
    });
    if (result.status === 204)
      return {
        errors: {},
        message: "Dietary Preference updated successfully.",
        defaultValues,
        success: true,
      };
  } catch (error) {
    console.error("Error updating dietary preference:", error);
  }
  return {
    errors: {},
    message: "Failed to update dietary preference.",
    defaultValues,
    success: false,
  };
}

export async function deleteDietaryPreference(
  id: string
): Promise<{ success: boolean }> {
  try {
    const result = await api.deleteDietaryPreference(parseInt(id));
    return { success: result.status === 204 };
  } catch (error) {
    console.error("Database Error:", error);
  }
  return { success: false };
}



